var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContainerW(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #fff;\r\n        stroke-width: 0px;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2.7,11.1h1.3l9.5-4.1c-.2-.4-.3-.8-.3-1.3,0-1.5,1-2.8,2.4-3.2V.9c0-.5.4-.9.9-.9s.9.4.9.9v2.4c0,.5-.4.9-.9.9-.8,0-1.5.7-1.5,1.6s0,.4.1.6l.5-.2c.2,0,.5,0,.7,0l1.3.6c.3-.4.4-.8.4-1.2s.4-.9.9-.9.9.4.9.9-.2,1.2-.4,1.6l8.7,3.8h1.3c1.5,0,2.7,1.2,2.7,2.7v15.6c0,1.5-1.2,2.7-2.7,2.7H2.7c-1.5,0-2.7-1.2-2.7-2.7v-15.5c0-1.5,1.2-2.7,2.7-2.7ZM1.8,29.3c0,.5.4.9.9.9h26.7c.5,0,.9-.4.9-.9v-15.5c0-.5-.4-.9-.9-.9H2.7c-.5,0-.9.4-.9.9v15.5ZM17.9,8.6c-.4.2-.9.3-1.4.3s-1.3-.2-1.8-.6l-6.2,2.7h15.2l-5.8-2.4Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3.5,14.7v13.8h24.9v-13.8H3.5ZM7.5,26.4c0,.5-.4.9-.9.9s-.9-.4-.9-.9v-9.5c0-.5.4-.9.9-.9s.9.4.9.9v9.5ZM12.2,26.4c0,.5-.4.9-.9.9s-.9-.4-.9-.9v-9.5c0-.5.4-.9.9-.9s.9.4.9.9v9.5ZM16.9,26.4c0,.5-.4.9-.9.9s-.9-.4-.9-.9v-9.5c0-.5.4-.9.9-.9s.9.4.9.9v9.5ZM21.5,26.4c0,.5-.4.9-.9.9s-.9-.4-.9-.9v-9.5c0-.5.4-.9.9-.9s.9.4.9.9v9.5ZM26.2,26.4c0,.5-.4.9-.9.9s-.9-.4-.9-.9v-9.5c0-.5.4-.9.9-.9s.9.4.9.9v9.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContainerW);
export default __webpack_public_path__ + "static/media/container-w.fefae0055c93d78bca42b15d4696e517.svg";
export { ForwardRef as ReactComponent };